/**
 * How much of an uncaught error's text a dashboard analytics event carries.
 *
 * Copy of `apps/frontend/app/analytics/error-text.ts` below the marker line:
 * the two apps share no package and do not import from each other, so each
 * carries the rule. `__tests__/error-text.spec.ts` fails when the two copies
 * differ; change both together.
 */
// --- shared with apps/frontend/app/analytics/error-text.ts ---
export const ERROR_TEXT_LIMIT = 120

/** The first `ERROR_TEXT_LIMIT` characters of `text`; empty when there is none. */
export function errorText(text: string | null | undefined): string {
  return (text ?? '').slice(0, ERROR_TEXT_LIMIT)
}

/** A promise rejection's reason as text, cut like `errorText`. */
export function rejectionReasonText(reason: unknown): string {
  if (reason instanceof Error) return errorText(reason.message || reason.toString())
  if (typeof reason === 'string') return errorText(reason)
  // `JSON.stringify(undefined)` is undefined, which `errorText` reads as empty.
  return errorText(JSON.stringify(reason))
}
